export default class CreateNotificationController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        if (!this.action) {
            this.action = false;
        }
    }

    close() {
        this.onClose(
            this.eventEmitter({
                action: this.action
            })
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/actions/create-notification/create-notification.controller.js